import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Payment Settings</h4>
    </div>
  );
};
